module.exports = __webpack_public_path__ + "img/pageTitle.c98fbcea.jpg";